export const adminCreateConnection = `mutation adminCreateConnection($input: ConnectionCreateInput!) {
  adminCreateConnection(input: $input) {
    connectionId
  }
}`;

export const adminUpdateConnection = `mutation adminUpdateConnection($input: ConnectionUpdateInput!) {
  adminUpdateConnection(input: $input) {
    connectionId
    name
    type
    description
    active
    databases {
      name
      label
    }
  }
}`;

export const adminDeleteConnection = `mutation adminDeleteConnection($connectionId: ID!) {
  adminDeleteConnection(connectionId: $connectionId) {
      connectionId
  }
}`;
